
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';

import { NgxSpinnerModule } from 'ngx-spinner';

import { UtilService } from 'src/app/shared/services/util.service';
import { GestionarIncentivoBicicletaComponent } from './gestionar-incentivo-bici.component';
import { GestionarIncentivoBicicletaRouting } from './gestionar-incentivo-bici.routing';
import { FuncionariosIncentivoBiciComponent } from './funcionarios-incentivo-bici.component';

@NgModule({
    declarations: [
        GestionarIncentivoBicicletaComponent,
        FuncionariosIncentivoBiciComponent
    ],
    imports: [
        NgxSpinnerModule,
        SharedModule,
        CommonModule,
        GestionarIncentivoBicicletaRouting
    ],
    entryComponents: [

    ]
    , providers: [
        UtilService]
})

export class GestionarIncentivoBicicletaModule { }
